/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PropertyLocalCreateType } from './propertyLocalCreateType';

export interface PropertyLocalCreate {
  /**
     * @minLength 1
     * @maxLength 80
     */
  name: string;
  type: PropertyLocalCreateType;
  value: unknown;
}
